import { NgModule } from '@angular/core';
import { CatalogStoreModule } from '@catalog/data-access';
import { CatalogDataAccessModule } from '@catalog/data-access/v2';
import { CatalogFeatureModule } from '@catalog/feature';
import { CatalogFeatureModule as CatalogFeatureModuleV2 } from '@catalog/feature/v2';
import { CatalogUtilsModule } from '@catalog/utils';
import { CustomProductListCmsComponents } from '@core/const';
import { ProductConvertersModule } from '@product/utils';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    CatalogUtilsModule,
    ProductConvertersModule,
    CatalogFeatureModule,
    CatalogFeatureModuleV2,
    CatalogStoreModule,
    CatalogDataAccessModule.forRoot(),
    ConfigModule.withConfig({
      featureModules: {
        customProductList: {
          module: () => import('./lazy/custom-product-list.module').then((m) => m.ProductListModule),
          cmsComponents: [
            CustomProductListCmsComponents.ProductGridComponent,
            CustomProductListCmsComponents.SearchResultsGridComponent,
            CustomProductListCmsComponents.CMSProductListComponent,
            CustomProductListCmsComponents.SearchResultsListComponent,
          ],
        },
        ProductFacetNavigation: {
          module: () =>
            import('./lazy/product-facet-navigation.module').then((m) => m.SdCustomProductFacetNavigationModule),
          cmsComponents: [CustomProductListCmsComponents.ProductRefinementComponent],
          dependencies: [],
        },
        CategoryTags: {
          module: () => import('./lazy/category-tags.module').then((m) => m.SdCategoryTagsModule),
          cmsComponents: [CustomProductListCmsComponents.CategoryTagsComponent],
        },
        SearchTaps: {
          module: () => import('./lazy/search-taps.module').then((m) => m.SdSearchTapsModule),
          cmsComponents: [CustomProductListCmsComponents.SdCMSSearchTapsComponent],
        },
      },
    }),
  ],
})
export class SdvorCatalogShellModule {}
